import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Achievement} from '@modules/achievement/core/services/user-score.service';
import { brand } from 'app/settings';

@Component({
    templateUrl: './achievement-dialog.component.html',
    standalone: false
})
export class AchievementDialog {

    public brand = brand;

    constructor(@Inject(MAT_DIALOG_DATA) public data: Achievement) {
    }
}